<template>
    <div class="page-wrapper game-score">
        <PageHeader/>

        <main class="main-hero">
            <div class="container position-relative">
                <h1 class="d-none d-lg-block mb-0">
                    <strong v-if="percentage > score.good">{{ trans('game_over.score_good_1', 'You\'re tearing') }} <br>
                        {{ trans('game_over.score_good_2', 'up the dancefloor!') }}</strong>
                    <strong v-else-if="percentage > score.week">{{ trans('game_over.score_weak_1', 'You\'re getting') }}
                        <br> {{ trans('game_over.score_weak_2', 'your groove on!') }}</strong>
                    <strong v-else>{{ trans('game_over.score_bad', 'Practice makes perfect!') }}</strong>
                </h1>

                <div class="row mb-0 mb-sm-5">
                    <div class="col-lg-6 hero-text prize-info">
                        <div class="form-block">
                            <h3 class="text-primary text-uppercase">
                                <strong>
                                    {{ trans('game_over.you_won', 'You just won :discount EUR discount', {
                                    discount: discount
                                    }) }}
                                </strong>
                            </h3>

                            <div class="row">
                                <div class="col form-col">
                                    <p>
                                        {{ trans('game_over.use_this_voucher', 'Use this voucher now for your next flight and play again for a bigger discount') }}
                                    </p>

                                    <div class="input-group">
                                        <input type="text" class="form-control" name="voucher" :value="code"
                                               disabled/>
                                        <div class="input-group-append">
                                            <a href="#" class="btn btn-primary" @click="searchFlights()"
                                               style="min-width: 129px;">
                                                {{ trans('game_over.search_fligts', 'search flights') }}
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="col button-col">
                                    <a href="#" class="btn btn-circle btn-primary" @click="playAgain()">
                                        {{ trans('game_over.play_again', 'play again') }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="form-block">
                            <h3 class="text-primary text-uppercase js-subscribe-text">
                                <strong>{{ trans('game_over.win_flight', 'Win a Free Roundtrip Flight') }}</strong>
                            </h3>

                            <div class="row">
                                <div class="col form-col d-flex flex-column justify-content-center">
                                    <div class="js-form-holder">
                                        <p class="js-subscribe-error text-danger"></p>

                                        <div class="js-subscribe-form">
                                            <p>
                                                {{ trans('game_over.subscribe', 'Subscribe to our newsletter to win') }}
                                            </p>

                                            <form class="js-subscribe-form" action="" method="POST"
                                                  @submit.prevent="subscribe">
                                                <div class="input-group">
                                                    <input type="email" class="form-control" name="email"
                                                           v-model="email"
                                                           placeholder="your e-mail" required/>
                                                    <div class="input-group-append">
                                                        <button type="submit" class="btn btn-primary">
                                                            {{ trans('game_over.submit', 'submit') }}
                                                        </button>
                                                    </div>
                                                </div>

                                                <div class="form-checkbox">
                                                    <input type="checkbox" id="newsletter" name="newsletter" value="1"/>
                                                    <label for="newsletter" class="mb-0">
                                                        <span class="checkmark"></span>
                                                        <span>{{ trans('game_over.checkmark', 'Yes, I want to receive airBaltic newsletter and participate in a lottery to win a free flight.') }}</span>
                                                    </label>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    <p class="mb-0 js-subscribe-success" style="display: none;">
                                        {{ trans('game_over.thank_you', 'Thank You for subscribing to our newsletter!') }}
                                    </p>
                                </div>

                                <div class="col button-col d-none d-sm-flex">
                                    <button type="button" class="btn btn-sm btn-circle btn-round-circle btn-outline flex-shrink-0"
                                            data-toggle="modal" data-target="#rulesModal">
                                        <span>{{ trans('game_over.rules', 'rules') }}</span>
                                    </button>
                                </div>
                            </div>

                            <nav class="share-nav d-flex d-lg-none">
                                {{ trans('game_over.share', 'Share your results') }}
                                <ul>
                                    <li>
                                        <a href="javascript:;" data-link="" @click="shareFacebook($event)">
                                            <svg width="34" height="34" viewBox="0 0 34 34"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M32.124 0H1.876C.84 0 0 .84 0 1.876v30.248C0 33.16.84 34 1.876 34h16.296V20.851h-4.425v-5.147h4.425v-3.786c0-4.391 2.685-6.783 6.601-6.783 1.32-.003 2.639.064 3.951.2v4.59h-2.696c-2.134 0-2.55 1.008-2.55 2.497v3.277h5.1l-.663 5.147h-4.467V34h8.676C33.16 34 34 33.16 34 32.124V1.876C34 .84 33.16 0 32.124 0z"
                                                      fill="#152649" fill-rule="evenodd"/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;" data-tweet="AirBaltic twitter message"
                                           @click="shareTwitter($event)">
                                            <svg width="33" height="28" viewBox="0 0 33 28"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.669 27.352c12.336 0 19.084-10.291 19.084-19.218 0-.293-.006-.583-.02-.874a13.705 13.705 0 0 0 3.346-3.497 13.323 13.323 0 0 1-3.85 1.062 6.772 6.772 0 0 0 2.947-3.735 13.388 13.388 0 0 1-4.259 1.64A6.678 6.678 0 0 0 23.023.596c-3.705 0-6.71 3.024-6.71 6.754 0 .53.06 1.046.175 1.54C10.914 8.607 5.97 5.92 2.663 1.831a6.768 6.768 0 0 0-.91 3.396 6.768 6.768 0 0 0 2.984 5.622 6.625 6.625 0 0 1-3.037-.846v.085c0 3.271 2.311 6.002 5.38 6.621a6.677 6.677 0 0 1-3.03.115c.855 2.683 3.33 4.637 6.267 4.692a13.407 13.407 0 0 1-8.33 2.89c-.54 0-1.075-.031-1.6-.092a18.864 18.864 0 0 0 10.282 3.037"
                                                      fill="#152649" fill-rule="evenodd"/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;" @click="shareWhatsapp()">
                                            <svg width="35" height="34" viewBox="0 0 35 34"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path d="M34.2 16.562c0 9.147-7.472 16.562-16.691 16.562-2.927 0-5.676-.748-8.068-2.06L.2 34l3.013-8.886a16.388 16.388 0 0 1-2.395-8.552C.818 7.415 8.29 0 17.509 0 26.729 0 34.2 7.415 34.2 16.562zM17.509 2.638c-7.738 0-14.033 6.246-14.033 13.924 0 3.047.993 5.869 2.673 8.164l-1.753 5.171 5.393-1.714a14.024 14.024 0 0 0 7.72 2.304c7.738 0 14.033-6.246 14.033-13.924 0-7.678-6.295-13.925-14.033-13.925zm8.429 17.739c-.104-.17-.376-.271-.785-.474-.41-.203-2.421-1.186-2.795-1.32-.375-.136-.649-.204-.921.202-.273.407-1.057 1.32-1.296 1.592-.239.271-.477.305-.887.102-.408-.203-1.726-.632-3.29-2.015-1.215-1.076-2.037-2.404-2.275-2.81-.239-.407-.025-.626.179-.828.184-.183.41-.475.614-.711.205-.238.273-.407.409-.678.137-.27.068-.508-.034-.711-.102-.203-.921-2.2-1.262-3.014-.34-.812-.681-.677-.92-.677s-.512-.034-.785-.034a1.51 1.51 0 0 0-1.091.508c-.375.407-1.431 1.389-1.431 3.386 0 1.998 1.465 3.928 1.67 4.198.204.27 2.83 4.503 6.989 6.129 4.16 1.625 4.16 1.083 4.91 1.015.75-.068 2.42-.982 2.762-1.93.34-.949.34-1.761.239-1.93z"
                                                      fill="#152649" fill-rule="nonzero"/>
                                            </svg>
                                        </a>
                                    </li>
                                    <li class="d-flex d-sm-none ml-auto mr-0">
                                        <button type="button" class="btn btn-sm btn-circle btn-outline"
                                                data-toggle="modal" data-target="#rulesModal">
                                            {{ trans('game_over.rules', 'rules') }}
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="col-lg-6 d-flex flex-column">
                        <div class="d-block d-lg-none text-center">
                            <h3>
                                <strong v-if="percentage > score.good">
                                    {{ trans('game_over.score_good_1', 'You\'re tearing') }} <br>
                                    {{ trans('game_over.score_good_2', 'up the dancefloor!') }}
                                </strong>
                                <strong v-else-if="percentage > score.week">
                                    {{ trans('game_over.score_weak_1', 'You\'re getting') }} <br>
                                    {{ trans('game_over.score_weak_2', 'your groove on!') }}
                                </strong>
                                <strong v-else>{{ trans('game_over.score_bad', 'Practice makes perfect!') }}</strong>
                            </h3>

                            <strong class="score mb-3">
                                {{ trans('game_over.your_score', 'Your score') }}: {{ hits ? hits : 0 }}
                            </strong>
                        </div>

                        <div class="hero-image flex-grow-1">
                            <img src="../assets/reindeer-2.png" alt="Image"/>
                        </div>

                        <div class="results-wrapper">
                            <nav class="share-nav mr-3">
                                {{ trans('game_over.share', 'Share your results') }}
                                <ul>
                                    <li>
                                        <a href="javascript:;" data-tweet="AirBaltic twitter message"
                                           @click="shareTwitter($event)">
                                            <img src="../assets/svg/icons/twitter.svg" alt="Twitter"/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;" data-link="" @click="shareFacebook($event)">
                                            <img src="../assets/svg/icons/facebook.svg" alt="Facebook"/>
                                        </a>
                                    </li>
                                </ul>
                            </nav>

                            <h3 class="score mb-0 mt-3">
                                <strong>
                                    {{ trans('game_over.your_score', 'Your score') }}: {{ hits ? hits : 0 }}
                                </strong>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hero-pattern">
                <div class="pattern-inner">
                    <div class="pattern-block flex-fill" v-for="n in [1, 2, 3, 4, 5, 6]">
                        <span class="pattern-item" v-for="i in [1, 2, 3, 4, 5]"></span>
                    </div>
                </div>
            </div>
        </main>

        <RulesModal/>
    </div>
</template>

<script>
    import RulesModal from '@/components/RulesModal.vue'
    import PageHeader from '@/components/PageHeader.vue'

    export default {
        name: 'GameScore',
        components: {
            RulesModal,
            PageHeader
        },

        data() {
            return {
                key: '_' + Math.random().toString(36).substr(2, 9),
                hits: this.$route.params.hits ? this.$route.params.hits : null,
                hits_needed: this.$route.params.hits_needed ? this.$route.params.hits_needed : null,

                score: {
                    good: 75,
                    weak: 50
                },

                email: ''
            }
        },

        computed: {
            percentage() {
                if (this.hits < 1) {
                    return 0
                }

                return this.hits * 100 / this.hits_needed
            },

            discount() {
                let score = this.percentage
                let discount = 5

                if (score >= this.score.weak) {
                    discount = 10
                }

                if (score >= this.score.good) {
                    discount = 15
                }

                return discount
            },

            code() {
                let discount = this.discount;
                let codes = {
                    5: 'DANCER5',
                    10: 'DANCERX10',
                    15: 'DANCERS15'
                }

                return codes[discount];
            },

            flightUrl() {
                let locale = localStorage.getItem('locale');
                if (!locale) {
                    locale = 'en';
                }

                locale = locale.toUpperCase();

                return 'https://www.airbaltic.com/' + locale + '/index?opentab=FLT&origin=RIX&numjrny=2&evoucher[]=' + this.code + '&flt_leaving_on=10.01.2019&origin_type=A';
            }
        },

        created() {
            let hits = this.hits
            let needed = this.hits_needed

            if (hits !== null && needed !== null) {
                localStorage.setItem('hits', hits)
                localStorage.setItem('hits_needed', needed)
            }

            let storageHits = localStorage.getItem('hits')
            let storageNeededHits = localStorage.getItem('hits_needed')

            if (storageHits) {
                this.hits = storageHits
            }

            if (storageNeededHits) {
                this.hits_needed = storageNeededHits
            }

            $('body').removeClass('with-bg').removeAttr('style');

            dataLayer.push({
                event: 'GAevent',
                eventCategory: 'LP - Xmasdancer',
                eventAction: 'Game finished',
                eventLabel: 'Loaded; Lang:' + localStorage.getItem('locale')+'; Coupon: ' + this.code,
                nonInteraction: true
            });
        },

        methods: {
            shareFacebook(event) {
                let $button = $(event.currentTarget)
                let dataUrl = $button.attr('data-url') || ''
                let facebookWindow = window.open(
                    'https://www.facebook.com/sharer/sharer.php?u=' + dataUrl,
                    'facebook-popup', 'height=350, width=600'
                )

                if (facebookWindow.focus) {
                    facebookWindow.focus()
                }

                dataLayer.push({
                    event: 'GAevent',
                    eventCategory: 'LP - Xmasdancer',
                    eventAction: 'Game finished',
                    eventLabel: 'Share facebook; Lang:' + localStorage.getItem('locale'),
                    nonInteraction: false
                });

                return false
            },

            shareTwitter(event) {
                let $button = $(event.currentTarget)

                let dataTweet = this.trans('share.twitter', 'Come play this game :url, I got :points out of :points_needed', {
                    url: window.location.origin,
                    points: this.hits,
                    points_needed: this.hits_needed
                });

                let twitterWindow = window.open(
                    'http://twitter.com/intent/tweet?text=' + dataTweet,
                    'twitter-popup', 'height=350, width=600'
                )

                if (twitterWindow.focus) {
                    twitterWindow.focus()
                }

                dataLayer.push({
                    event: 'GAevent',
                    eventCategory: 'LP - Xmasdancer',
                    eventAction: 'Game finished',
                    eventLabel: 'Share twitter; Lang:' + localStorage.getItem('locale'),
                    nonInteraction: false
                });

                return false
            },

            shareWhatsapp(text) {
                if (!text) {
                    text = this.trans('share.whatsapp', 'Come play this game :url, I got :points out of :points_needed', {
                        url: window.location.origin,
                        points: this.hits,
                        points_needed: this.hits_needed
                    })
                }

                let url = 'whatsapp://send?text=' + encodeURIComponent(text)

                window.location = url
            },

            async subscribe(event) {
                $('.js-subscribe-error').hide();

                if (!$('#newsletter').is(':checked')) {
                    $('.js-subscribe-error').text(this.trans('game_over.checkbox_error', 'Please check the checkbox')).fadeIn().delay(5000).fadeOut();
                    return false;
                }

                if (!this.validateEmail(this.email) || !this.email) {
                    $('.js-subscribe-error').text(this.trans('game_over.email_error', 'Please enter a valid email address')).fadeIn().delay(5000).fadeOut();
                    return false;
                }

                try {
                    let response = this.$api.subscribe(this.email);

                    $('.js-subscribe-form').fadeOut();
                    $('.js-subscribe-success').fadeIn();

                    dataLayer.push({
                        event: 'GAevent',
                        eventCategory: 'LP - Xmasdancer',
                        eventAction: 'Game finished',
                        eventLabel: 'Subscribed; Lang:' + localStorage.getItem('locale'),
                        nonInteraction: false
                    });
                } catch (e) {
                    $('.js-subscribe-error').text(this.trans('game_over.server', 'Server error')).show().delay(5000).fadeOut();
                }
            },


            /**
             * I know, that JS shouldn't be used to validate user input, but don't worry, backend validation still persists.
             *
             * @param email
             * @return {boolean}
             */
            validateEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },

            playAgain () {
                dataLayer.push({
                    event: 'GAevent',
                    eventCategory: 'LP - Xmasdancer',
                    eventAction: 'Game finished',
                    eventLabel: 'Play again; Lang:' + localStorage.getItem('locale'),
                    nonInteraction: false
                });

                this.$nextTick(() => {
                    this.$router.push({
                        name: 'game',
                        key: '_' + Math.random().toString(36).substr(2, 9)
                    });
                });
            },

            searchFlights() {
                dataLayer.push({
                    event: 'GAevent',
                    eventCategory: 'LP - Xmasdancer',
                    eventAction: 'Game finished',
                    eventLabel: 'Search flights; Lang:' + localStorage.getItem('locale'),
                    nonInteraction: false
                });

                this.$nextTick(() => {
                    window.location.href = this.flightUrl;
                });
            }
        }
    }
</script>
